export default "__VITE_ASSET__DcJanG7S__"